export const convertToF = celsius => celsius * (9 / 5) + 32;
